import React, { useState, useEffect } from "react";

const Resources = (props) => {
    const { setLoader, setOpacity, schoolId, acdYrId, studentId } = props;

    const [booksMagazines, setBooksMagazines] = useState(false);
    const [newsPaper, setNewsPaper] = useState(false);
    const [toysGamesSports, setToysGamesSports] = useState(false);
    const [phoneComputer, setPhoneComputer] = useState(false);
    const [internet, setInternet] = useState(false);

    useEffect(() => {
        // console.log("Resources called");
    }, []);

    const saveResourcesAtHome = () => {
        // console.log("saveResourcesAtHome called");
    };

    return (
        <div className="col-md-12 col-sm-12 col-xs-12 " style={{ border: "1px solid #ccc", borderRadius: "10px", padding:"10px 0" }}>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-5 col-sm-5 col-xs-12 padding-remove" >
                    <label className="control-label text-left col-md-12 col-sm-12 col-xs-12 " >
                        Resources at home
                    </label>
                </div>
            </div>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                <div className="col-md-6 col-sm-6 col-xs-12 padding-remove">
                    {/* Books/Magazines */}
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove form-group d-flex align-items-center">
                        <label className="col-md-10 col-sm-10 col-xs-9">Books/Magazines</label>
                        <input
                            type="checkbox"
                            className="col-md-2 col-sm-2 col-xs-3"
                            checked={booksMagazines}
                            onChange={(e) => setBooksMagazines(e.target.checked)}
                            onClick={(e) => { e.stopPropagation(); }}
                        />
                    </div>

                    {/* Newspaper */}
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove form-group d-flex align-items-center">
                        <label className="col-md-10 col-sm-10 col-xs-9">Newspaper</label>
                        <input
                            type="checkbox"
                            className="col-md-2 col-sm-2 col-xs-3"
                            checked={newsPaper}
                            onChange={(e) => setNewsPaper(e.target.checked)}
                            onClick={(e) => { e.stopPropagation(); }}
                        />
                    </div>

                    {/* Toys/Games/Sports */}
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove form-group d-flex align-items-center">
                        <label className="col-md-10 col-sm-10 col-xs-9">Toys/Games/Sports</label>
                        <input
                            type="checkbox"
                            className="col-md-2 col-sm-2 col-xs-3"
                            checked={toysGamesSports}
                            onChange={(e) => setToysGamesSports(e.target.checked)}
                            onClick={(e) => { e.stopPropagation(); }}
                        />
                    </div>

                    {/* Phone/Computer */}
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove form-group d-flex align-items-center">
                        <label className="col-md-10 col-sm-10 col-xs-9">Phone/Computer</label>
                        <input
                            type="checkbox"
                            className="col-md-2 col-sm-2 col-xs-3"
                            checked={phoneComputer}
                            onChange={(e) => setPhoneComputer(e.target.checked)}
                            onClick={(e) => { e.stopPropagation(); }}
                        />
                    </div>

                    {/* Internet */}
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-remove form-group d-flex align-items-center">
                        <label className="col-md-10 col-sm-10 col-xs-9">Internet</label>
                        <input
                            type="checkbox"
                            className="col-md-2 col-sm-2 col-xs-3"
                            checked={internet}
                            onChange={(e) => setInternet(e.target.checked)}
                            onClick={(e) => { e.stopPropagation(); }}
                        />
                    </div>
                </div>

            </div>
            <div className="col-md-6 col-sm-6 col-xs-12 padding-remove" style={{ margin: "20px 0" }}>
                <div className="col-md-6 col-sm-6 col-xs-12 pull-right padding-remove">
                    <div className="form-group col-md-9 col-sm-9 col-sm-10">
                        <button
                            className="pull-right btn btn-info"
                            onClick={saveResourcesAtHome}
                            title="Save"
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Resources;
